<div class="section feather-bg-img" style="background-image: url(assets/images/bg/17.png);" id="features">
  <div class="container mt-5">
    <div class="row">
      <div class="col-lg-6">
        <div class="mb-5 mt-4">
          <p class="font-weight-bold">
            <i class="mdi mdi-chart-bubble h2 text-primary mr-1 align-middle"></i> {{'features2.accProcess' |
            translate}}
          </p>
          <hr style="margin-top: -10px;">
          <div class="mb-5" *ngIf="isMobile">
            <img src="assets/images/feature-undraw/feature-2.png" width="90%">
          </div>
          <h3 class="text-dark font-weight-bold mb-3 font-mobile">
            <div innerHTML="{{'features2.accProcessheader' | translate}}"></div>
          </h3>
          <p class="font-size-16">
            {{'features2.accProcessSub' | translate}}
          </p>
        </div>
      </div>
      <!-- <div class="col-lg-1"></div> -->
      <div class="col-lg-6 mt-5 text-center" *ngIf="!isMobile">
        <img src="assets/images/feature-undraw/feature-2.png" width="90%">
      </div>
    </div>

  </div>
</div>

<section class="section feather-bg-img" style="background-image: url(assets/images/bg/17.png);">
  <div class="container">
    <div class="img-home">
      <ngb-carousel #carouselStart [showNavigationArrows]="false" [showNavigationIndicators]="false"
        (slide)="getIndexCarousel($event)">
        <ng-template ngbSlide>
          <img src="assets/images/ss-app/coa-mapping.png" class="d-block img-fluid" alt="slide 1">
        </ng-template>
        <ng-template ngbSlide>
          <img src="assets/images/ss-app/journal-voucher.png" class="d-block img-fluid" alt="slide 2">
        </ng-template>
        <ng-template ngbSlide>
          <img src="assets/images/ss-app/custom-period.png" class="d-block img-fluid" alt="slide 3">
        </ng-template>
      </ngb-carousel>
    </div>

    <div class="row" style="margin-top: 5em;">
      <div class="col-md-4">
        <div class="wc-box rounded text-center wc-box-primary p-4 carousel-card"
          [ngClass]="{'carousel-active': indexCarousel === 'ngb-slide-0'}" (click)="goToCarousel('ngb-slide-0')">
          <div class="wc-box-icon">
            <i class="mdi mdi-map"></i>
          </div>
          <p class="font-weight-bold mb-2 wc-title mt-4">CoA Mapping & Auto Journal</p>
          <p class="text-muted mb-0 font-size-15 wc-subtitle">
            {{'features2.carousel1Sub' | translate}}
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="wc-box rounded text-center wc-box-primary p-4 carousel-card"
          [ngClass]="{'carousel-active': indexCarousel === 'ngb-slide-1'}" (click)="goToCarousel('ngb-slide-1')">
          <div class="wc-box-icon">
            <i class="mdi mdi-receipt"></i>
          </div>
          <p class="font-weight-bold mb-2 wc-title mt-4">{{'features2.carousel2' | translate}}</p>
          <p class="text-muted mb-0 font-size-15 wc-subtitle">
            {{'features2.carousel2Sub' | translate}}
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="wc-box rounded text-center wc-box-primary p-4 carousel-card"
          [ngClass]="{'carousel-active': indexCarousel === 'ngb-slide-2'}" (click)="goToCarousel('ngb-slide-2')">
          <div class="wc-box-icon">
            <i class="mdi mdi-calendar-multiple"></i>
          </div>
          <p class="font-weight-bold mb-2 wc-title mt-4">{{'features2.carousel3' | translate}}</p>
          <p class="text-muted mb-0 font-size-15 wc-subtitle">
            {{'features2.carousel3Sub' | translate}}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-block-quote3></app-block-quote3>

<section class="section feather-bg-img" style="background-image: url(assets/images/bg/9.png)">
  <div class="container">
    <div class="row align-items-center">
      <div *ngIf="isMobile">
        <img src="assets/images/ss-app/gl-process.png" class="img-fluid d-block w-100">
      </div>
      <div class="col-lg-6">
        <div innerHTML="{{'features2.detailheader1' | translate}}"></div>
        <p class="font-size-15 mb-4">
          {{'features2.detailSub1' | translate}}
        </p>
        <ul style="margin-left: -1px;">
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>Auto Journal</b>
              Depreciation
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>Auto Journal</b>
              Recurring
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>Post Forex</b> Realized
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>Post Forex</b> Unrealized
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>Post Monthly</b> Profit
              and Loss
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>End of</b> Periode
            </p>
          </li>
        </ul>
      </div>
      <div class="col-lg-6" *ngIf="!isMobile">
        <div class="mt-5">
          <br>
          <img src="assets/images/ss-app/gl-process.png" class="img-fluid d-block w-100">
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section feather-bg-img" style="background-color: #f8f9fa;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="setup">
          <img src="assets/images/ss-app/setup-menu.png" class="img-fluid d-block w-100">
        </div>
      </div>
      <div class="col-lg-5 offset-lg-1">
        <div innerHTML="{{'features2.detailheader2' | translate}}"></div>
        <ul>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>{{'features2.period1Bold'
                | translate}}</b> <br>
              {{'features2.period1' | translate}}
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>{{'features2.period2Bold'
                | translate}}</b> <br>
              {{'features2.period2' | translate}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- <app-testimonial></app-testimonial> -->

<section class="section feather-bg-img" style="background-image: url(assets/images/bg/9.png)">
  <div class="container">
    <div class="row align-items-center">
      <div class="mt-5" *ngIf="isMobile">
        <img src="assets/images/ss-app/journal-type.png" class="img-fluid d-block w-100">
      </div>
      <div class="col-lg-5">
        <div innerHTML="{{'features2.detailheader3' | translate}}"></div>
        <ul>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>{{'features2.jurnal1Bold'
                | translate}}</b>
              <br>
              {{'features2.jurnal1' | translate}}
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather> <b>{{'features2.jurnal2Bold'
                | translate}}</b> <br>
              {{'features2.jurnal2' | translate}}
            </p>
          </li>
        </ul>
      </div>
      <div class="col-lg-6 offset-lg-1" *ngIf="!isMobile">
        <div class="mt-5">
          <img src="assets/images/ss-app/journal-type.png" class="img-fluid d-block w-100">
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section feather-bg-img" style="background-color: #f8f9fa;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="mb-4 mb-lg-0">
          <img src="assets/images/ss-app/period-acc-13.png" class="img-fluid d-block w-100">
        </div>
      </div>
      <div class="col-lg-5 offset-lg-1">
        <div innerHTML="{{'features2.detailheader4' | translate}}"></div>
        <ul>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather>
              <b>{{'features2.periode1Bold' | translate}}</b> <br>
              {{'features2.periode1' | translate}}
            </p>
          </li>
          <li>
            <p class="mb-2 font-size-15">
              <i-feather class="icon-xs mr-1 text-primary" name="check-circle"></i-feather>
              <b>{{'features2.periode2Bold' | translate}}</b> <br>
              {{'features2.periode2' | translate}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<app-accounting-process-collapse></app-accounting-process-collapse>